$(function () {
	const targetBlock = $('.js-animate-text span');

	if (targetBlock.length) {
		$(window).scroll(function () {
			let currentScroll = $(window).scrollTop();

			$.each(targetBlock, function () {
				let targetBlockOffset = $(this).offset().top;
				let targetBlockHeight = $(this).outerHeight();
				let scrollStart;

				if ($(window).width() > 1023) {
					scrollStart = 200;
				} else {
					scrollStart = 100;
				}

				let step = (currentScroll - (targetBlockOffset - (targetBlockHeight + scrollStart))) / targetBlockHeight;
				let number = Math.round(-step * 100);

				if (!$(this).hasClass('animate-text-stop') && number <= 0 && number >= -100) {
					$(this).css('backgroundPosition', `${number}% 0`);
				}

				if (currentScroll >= (targetBlockOffset + targetBlockHeight) || number <= -100) {
					$(this).css('backgroundPosition', `-100% 0`).addClass('animate-text-stop');
				}
			});
		});
	}
})